module.exports = __webpack_public_path__ + "img/roller_300.94c3d30e.jpg";